export const RTC_NAMESPACE = 'rtc';
